'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MealPlanner = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user };
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(MealPlanner, _Component);

  function MealPlanner() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, MealPlanner);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MealPlanner.__proto__ || (0, _getPrototypeOf2.default)(MealPlanner)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      meals: [{
        name: 'Breakfast',
        days: ['', '', '', '', '', '', '']
      }, {
        name: 'Lunch',
        days: ['', '', '', '', '', '', '']
      }, {
        name: 'Dinner',
        days: ['', '', '', '', '', '', '']
      }, {
        name: 'Snacks',
        days: ['', '', '', '', '', '', '']
      }]
    }, _this.handleChange = function (mealIndex, dayIndex, event) {
      var obj = _this.state;
      obj.meals[mealIndex].days[dayIndex] = event.target.value;
      _this.setState(obj);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /*
   * General function used to change state of object
   */


  (0, _createClass3.default)(MealPlanner, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          ReactBootstrap.Table,
          { bordered: true, striped: true },
          _react2.default.createElement(
            'thead',
            null,
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement('th', null),
              this.state.days.map(function (item) {
                return _react2.default.createElement(
                  'th',
                  null,
                  item
                );
              })
            )
          ),
          _react2.default.createElement(
            'tbody',
            null,
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                null,
                this.state.meals[0].name
              ),
              this.state.meals[0].days.map(function (item, index) {
                return _react2.default.createElement(
                  'td',
                  null,
                  _react2.default.createElement(ReactBootstrap.FormControl, {
                    type: 'text',
                    value: item,
                    placeholder: 'What do I want to make?',
                    onChange: _this2.handleChange.bind(_this2, 0, index) })
                );
              })
            ),
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                null,
                this.state.meals[1].name
              ),
              this.state.meals[1].days.map(function (item, index) {
                return _react2.default.createElement(
                  'td',
                  null,
                  _react2.default.createElement(ReactBootstrap.FormControl, {
                    type: 'text',
                    value: item,
                    placeholder: 'What do I want to make?',
                    onChange: _this2.handleChange.bind(_this2, 1, index) })
                );
              })
            ),
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                null,
                this.state.meals[2].name
              ),
              this.state.meals[2].days.map(function (item, index) {
                return _react2.default.createElement(
                  'td',
                  null,
                  _react2.default.createElement(ReactBootstrap.FormControl, {
                    type: 'text',
                    value: item,
                    placeholder: 'What do I want to make?',
                    onChange: _this2.handleChange.bind(_this2, 2, index) })
                );
              })
            ),
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                null,
                this.state.meals[3].name
              ),
              this.state.meals[3].days.map(function (item, index) {
                return _react2.default.createElement(
                  'td',
                  null,
                  _react2.default.createElement(ReactBootstrap.FormControl, {
                    type: 'text',
                    value: item,
                    placeholder: 'What do I want to make?',
                    onChange: _this2.handleChange.bind(_this2, 3, index) })
                );
              })
            )
          )
        )
      );
    }
  }]);
  return MealPlanner;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object
}, _temp2)) || _class);
exports.default = MealPlanner;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/2/Components/MealPlanner.js
// module id = 1191
// module chunks = 0